import { Region } from '@enums/RegionList';

const PercentageRegion = {
  [Region.Moscow]: '40%',
};

export const getPercentage = (regionId: number): string => {
  return PercentageRegion[regionId] || '50%';
};
